import amplitudeService from '@/services/AmplitudeService';
import { DirectiveOptions } from 'vue';

interface AmplitudeClickConfig {
    label?: string;
    properties?: Record<string, string>;
}

interface AmplitudeElement extends HTMLElement {
    _amplitudeClickHandler?: () => void;
    _amplitudeClickBinding?: string | AmplitudeClickConfig;
}

const amplitudeClickDirective: DirectiveOptions = {
    bind(el: AmplitudeElement, binding) {
        el._amplitudeClickBinding = binding.value;
        const handler = () => {
            const value = el._amplitudeClickBinding;
            const config = typeof value === 'object' ? value : null;
            const label: string =
                (typeof value === 'string' ? value : config?.label) ||
                (el as HTMLElement).dataset?.amplitudeLabel ||
                (el as HTMLElement).innerText?.trim().substring(0, 100) ||
                (el as HTMLElement).getAttribute('aria-label') ||
                'unknown';
            amplitudeService.trackButtonClick(label, undefined, config?.properties);
        };
        el._amplitudeClickHandler = handler;
        el.addEventListener('click', handler);
    },
    update(el: AmplitudeElement, binding) {
        el._amplitudeClickBinding = binding.value;
    },
    unbind(el: AmplitudeElement) {
        if (el._amplitudeClickHandler) {
            el.removeEventListener('click', el._amplitudeClickHandler);
            delete el._amplitudeClickHandler;
        }
        delete el._amplitudeClickBinding;
    }
};

export default amplitudeClickDirective;
